import React, { useState, useCallback, useEffect } from "react";
import { Row, Col, Button } from "antd";
import { useDropzone } from "react-dropzone";
import { v4 } from "uuid";
import Loader from "./Loader";
import "./UploadFile.css";

const UploadFiles = (props) => {
  const {
    setFileSelected,
    label = "Hace click o arrastrá acá (debe ser un sólo archivo)",
    fileSelected,
    onCompleteFileSelection,
  } = props;

  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (
      fileSelected === undefined ||
      fileSelected === null ||
      fileSelected.length <= 0
    ) {
      setFiles([]);
    }
  }, [fileSelected]);

  const handleRemoveFile = (id) => {
    const updatedFiles = files.filter((file) => file.id !== id);
    setFiles(updatedFiles);
    setFileSelected(updatedFiles);
  };

  function UploadFile() {
    const onDrop = useCallback(
      (acceptedFiles) => {
        if (acceptedFiles.length > 1) {
          setErrorMessage("⚠️ Solo puedes seleccionar un archivo.");
          return;
        }else{
          setErrorMessage("");
        }
        setIsLoading(true);
        const filesArray = acceptedFiles.map((file) => {
          const extSplit = file.name.split(".");
          const fileExt = extSplit[extSplit.length - 1];

          return {
            id: v4(),
            documentName: file.name,
            type: file.type,
            fileExtension: fileExt,
            file: file,
          };
        });
        setFiles([...files, ...filesArray]);
        setFileSelected((files)=>[...files, ...filesArray]);
        onCompleteFileSelection(filesArray);
        setIsLoading(false);
      },
      [setFiles, setFileSelected]
    );

    const { getRootProps, getInputProps } = useDropzone({
      noKeyboard: true,
      onDrop,
      // maxFiles: 1
    });

    return (
      <div className="dropzone-container" {...getRootProps()}>
        <input {...getInputProps()} />
        <div className="insertFile">
          {errorMessage && <p style={{ color: "red", fontWeight: "bold" }}>{errorMessage}</p>}
          {files.length > 0 ? (
            <div className="file-list">
              {files.map((file) => (
                <div className="file-item" key={file.id}>
                  <span className="file-name">
                    {file.documentName.substr(0, 20) + "... ." + file.fileExtension}
                  </span>
                  <Button
                    size="small"
                    danger
                    onClick={(e) => {
                      e.stopPropagation(); // Evita que el click se propague a la dropzone
                      handleRemoveFile(file.id);
                    }}
                  >
                    Eliminar
                  </Button>
                </div>
              ))}
            </div>
          ) : (
            <span style={{ color: "#c3c3c3" }}>{label}</span>
          )}
        </div>
      </div>
    );
  }

  return (
    <Row gutter={24}>
      <Col span={24}>
        { isLoading ? 
          (
            <Loader/>) : 
          (
            <UploadFile />
          )}
      </Col>
    </Row>
  );
};

export default UploadFiles;
